// extracted by mini-css-extract-plugin
export var hidden = "_ou-1";
export var visible = "_ou-0";